import { render, staticRenderFns } from "./PlaceOrders.vue?vue&type=template&id=6e91ae93&"
import script from "./PlaceOrders.vue?vue&type=script&lang=js&"
export * from "./PlaceOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports